
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/available-plans",
      function () {
        return require("private-next-pages/d/account/available-plans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/available-plans"])
      });
    }
  